module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "Prelims-head",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/JAMES-Paul-author.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main"
  }, [_vm._v("Paul James hails from Yorkshire and is now settled in London. He has led an eclectic mix of an existence, living and working on four continents. A former military man; aircraft engineer; semi-pro footballer; national security consultant; international businessman; poet and published author, Paul is an incurable primeval Scorpio romantic, with an artistic penchant for the ocean-deep intensity and surreal dark side in his writing, where he pushes the boundaries of poetic prose. His passionate nature and old-fashioned soul are as prevalent in his life as they are in his studious work, showcased in this unique poetry collection.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4024c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781788480116_EPUB.vue
// module id = 57
// module chunks = 0